import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const SimpleMarcField = ({ field, isPrint = false }) => {
  const fieldTag = Object.keys(field)[0];
  const hasIndicators = typeof field[fieldTag] !== 'string';

  const normalizeIndicator = (indicator) => {
    return indicator ? indicator.replace(/\\/g, ' ') : ' ';
  };

  const subFields = hasIndicators
    ? field[fieldTag].subfields?.map((subFieldTag, index) => {
      const subKey = Object.keys(subFieldTag)[0];
      return (
        <Fragment key={`subfield-${index}-${subKey}`}>
          <span>$</span>
          {subKey} {subFieldTag[subKey]}{' '}
        </Fragment>
      );
    })
    : field[fieldTag].replace(/\\/g, ' ');

  return (
    <tr data-test-instance-marc-field>
      <td />
      <td>{fieldTag}</td>
      {hasIndicators && (
        <td style={{ width: '30px' }}>
          {`${normalizeIndicator(field[fieldTag].ind1)} ${normalizeIndicator(field[fieldTag].ind2)}`}
        </td>
      )}
      <td colSpan={hasIndicators ? 2 : 3}>{subFields}</td>
    </tr>
  );
};

SimpleMarcField.propTypes = {
  field: PropTypes.object.isRequired,
  isPrint: PropTypes.bool,
};

export default SimpleMarcField;
